import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./sass/variable.scss";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueTouch from "vue-touch";
import * as VueGoogleMaps from "vue2-google-maps";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Rollbar from 'vue-rollbar';
import "swiper/swiper-bundle.css";

Vue.use(VueTouch);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_API_KEY,
    libraries: "places",
  },
  installComponents: true,
});

Vue.use(Rollbar, {
  accessToken: process.env.VUE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  environment: 'production',
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
      },
    },
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
